import { Enum } from './enum';
export var ColorPreset = Enum({
  WHITE: 'white',
  GRAY_100: 'gray100',
  GRAY_200: 'gray200',
  GRAY_300: 'gray300',
  GRAY_400: 'gray400',
  GRAY_500: 'gray500',
  GRAY_600: 'gray600',
  GRAY_700: 'gray700',
  GRAY_800: 'gray800',
  GRAY_900: 'gray900',
  BLACK: 'black',
  ALPHA_GRAY_100: 'gray100-alpha',
  ALPHA_GRAY_200: 'gray200-alpha',
  ALPHA_GRAY_300: 'gray300-alpha',
  ALPHA_GRAY_400: 'gray400-alpha',
  ALPHA_GRAY_500: 'gray500-alpha',
  ALPHA_GRAY_600: 'gray600-alpha',
  ALPHA_GRAY_700: 'gray700-alpha',
  ALPHA_GRAY_800: 'gray800-alpha',
  ALPHA_GRAY_900: 'gray900-alpha',
  GREEN: 'green',
  YELLOW: 'yellow',
  LIGHT_BLUE: 'light-blue',
  DARK_BLUE: 'dark-blue',
  RED: 'red',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  DANGER: 'danger'
});
export function getColorClass(color) {
  return "c--".concat(color);
}
export function getBGColorClass(color) {
  return "bg--".concat(color);
}